import { render, staticRenderFns } from "./PointOfSalesList.vue?vue&type=template&id=e0c3cb2a&"
import script from "./PointOfSalesList.vue?vue&type=script&lang=js&"
export * from "./PointOfSalesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports